import { render, staticRenderFns } from "./disputes-dialog-content.vue?vue&type=template&id=043c7227"
import script from "./disputes-dialog-content.vue?vue&type=script&lang=js"
export * from "./disputes-dialog-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports